import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    marginTop: 16,
    display: "flex",
    alignItems: "flex-start",
    borderBottom: "1px dashed #CACCD1",
    fontWeight: 500
  }
});

export default function DeviderLine() {
  const classes = useStyles();
  return <div className={classes.root}/>
};
